<template>
   <UApp>
      <NuxtLayout>
         <ClientOnly>
            <NuxtLoadingIndicator :height="5" color="var(--color-secondary)" />
            <Notification />
         </ClientOnly>

         <NuxtPage />
      </NuxtLayout>
   </UApp>
</template>
